import React, { useState } from "react";
import Dragger, { DraggerProps } from "antd/lib/upload/Dragger";
import { Spin, UploadProps } from "antd";
import { clsx } from "clsx";
import styles from "./UploadButton.module.less";
import { GenericGreyButton } from "./GenericGreyButton";

interface UploadButtonProps extends DraggerProps {
    title: string;
    description: string;
}

export const CustomUploadButton: React.FC<DraggerProps> = ({
    onChange,
    children,
    className,
    ...restProps
}) => {
    const [spinning, setSpinning] = useState(false);
    const handleChange: UploadProps["onChange"] = (info) => {
        setSpinning(true);
        if (info.file.status !== "uploading") {
            setSpinning(false);
        }
        onChange?.(info);
    };

    return (
        <Spin spinning={spinning}>
            <Dragger
                onChange={handleChange}
                {...restProps}
                className={clsx(styles.dragger, className)}
            >
                {children}
            </Dragger>
        </Spin>
    );
};

export const UploadButton: React.FC<UploadButtonProps> = ({ title, description, ...restProps }) => {
    return (
        <CustomUploadButton {...restProps}>
            <GenericGreyButton label={title} tip={description} />
        </CustomUploadButton>
    );
};
